import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import StorageListAccordion from '../common/components/LocationSelectionStep/StorageListAccordion';
import { assetGroupActivated, assetGroupDeactivated, setSelectedGroup } from '../../../redux/slice/bookingCreation/bookingCreationSlice';
import _ from "lodash";
import LoaderOverlay from '../../layout/components/LoaderOverlay';
import ListLoadError from '../common/components/ListLoadError';


function StorageSelectionStep() {
  const dispatch = useDispatch();
  const selectedLocation = useSelector(
    (state: RootState) => state.bookingCreation.selectedLocation
  );

    const storages = useSelector((state: RootState) =>
      selectedLocation ? state.bookingCreation.groupsByLocation[selectedLocation.id] : []
    ) || [];

  const selectedStorage = useSelector(
    (state: RootState) => state.bookingCreation.selectedGroup
  );
  const isLoading = _.isEmpty(storages);
  // `isLoading` is the list being empty, so a failed load spins forever
  // without this (#1970).
  const loadFailed = useSelector(
    (state: RootState) =>
      !!selectedLocation &&
      state.bookingCreation.groupsLoadFailedLocationId === selectedLocation.id
  );

  const handleAccordionChange = (storage: any) => {
    setExpandedAccordion(
      expandedAccordion === storage.id ? null : storage.id
    ); // Toggle the expanded accordion
    if (expandedAccordion === storage.id) {
      dispatch(assetGroupDeactivated());
    } else {
      dispatch(assetGroupActivated(storage));
      dispatch(setSelectedGroup(storage));
    }
  };

  const [expandedAccordion, setExpandedAccordion] = useState<string | null>(
    selectedStorage ? selectedStorage.id : null
  ); // Track the currently expanded accordion

  if (loadFailed) {
    return <ListLoadError messageKey="book_location.error.fetch_equipment" />;
  }

  return (
    <Box sx={{ padding: 1 }}>
      {storages?.map((item: any, index: number) =>
        item.priceCategory ? (
          <StorageListAccordion
            key={item.id}
            assetGroup={item}
            active={Boolean(expandedAccordion === item.id)}
            onToggle={() => handleAccordionChange(item)}
          />
        ) : null
      )}
      <LoaderOverlay open={isLoading} />
    </Box>
  )
}

export default StorageSelectionStep
